import React from "react"

const Skeleton = () => {
  return (
    <div
      style={{
        backgroundImage: `url(/images/main-background.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      className="min-h-screen w-full text-white"
    >
      <div className="flex flex-col md:flex-row w-full gap-6">
        <SidebarSkeleton />
        <div className="flex-1 px-4 space-y-6">
          <HeaderSkeleton />
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            <div className="lg:col-span-5 space-y-4">
              <FirstBox />
              <div className="space-y-3">
                <ThirdBox />
                <ThirdBox />
                <ThirdBox />
              </div>
            </div>
            <div className="lg:col-span-7 space-y-4">
              <SecondBox />
              <FourthBox />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Skeleton

const SidebarSkeleton = () => {
  return (
    <div className="bg-gradient-to-b from-gray-900 to-black flex justify-center w-[264px] min-h-screen hidden md:block">
      <div className="w-3/4 p-4">
        <div className="rounded animate-pulse my-10">
          <LineSvg />
        </div>
        <div className="rounded-lg animate-pulse space-y-4">
          <LineSvg />
          <LineSvg />
          <LineSvg />
        </div>
      </div>
    </div>
  )
}

export const HeaderSkeleton = () => (
  <div className="flex justify-between w-full mt-4">
    <div className="animate-pulse space-y-2">
      <LineSvg width="164" />
      <LineSvg width="102" />
    </div>
    <div className="w-[45px] h-[45px] rounded-full bg-[#6E2FC5] animate-pulse2" />
  </div>
)

const FirstBox = () => (
  <div
    className="rounded-[20px] w-full h-[344px] p-8 space-y-8"
    style={{
      background:
        "linear-gradient(127deg, rgba(6, 11, 38, 0.89) 28.26%, rgba(26, 31, 55, 0.50) 91.2%)",
      backdropFilter: "blur(60px)",
    }}
  >
    <div className="flex justify-between">
      <LineSvg height={30} />
      <LineSvg />
    </div>
    <LineSvg />
    <LineSvg width={120} />
    <div className="flex justify-between">
      <LongLineSvg />
      <LongLineSvg />
    </div>
    <LongLineSvg />
    <LongLineSvg />
  </div>
)

const SecondBox = () => (
  <div
    className="rounded-[20px] w-full h-[179px] p-8 space-y-4"
    style={{
      background:
        "linear-gradient(127deg, rgba(6, 11, 38, 0.89) 28.26%, rgba(26, 31, 55, 0.50) 91.2%)",
      backdropFilter: "blur(60px)",
    }}
  >
    <LineSvg />
    <br />
    <Line627 />
    <Line627 />
    <Line627 />
  </div>
)

const ThirdBox = () => (
  <div
    className="rounded-[20px] w-full h-[58px] p-8 space-y-4"
    style={{
      background:
        "linear-gradient(127deg, rgba(6, 11, 38, 0.89) 28.26%, rgba(26, 31, 55, 0.50) 91.2%)",
      backdropFilter: "blur(60px)",
    }}
  >
    <Line338 />
  </div>
)

const FourthBox = () => (
  <div
    className="rounded-[20px] w-full  p-8 space-y-4"
    style={{
      background:
        "linear-gradient(127deg, rgba(6, 11, 38, 0.89) 28.26%, rgba(26, 31, 55, 0.50) 91.2%)",
      backdropFilter: "blur(60px)",
    }}
  >
    <LineSvg />
    <div className="flex flex-col items-center justify-center gap-3">
      <EllipseSvg />
      <div className="flex gap-3">
        <ConsumptionSvg />
        <ConsumptionSvg />
      </div>
    </div>
  </div>
)

const ConsumptionSvg = () => (
  <svg
    width="191"
    height="46"
    viewBox="0 0 191 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="animate-pulse"
  >
    <g filter="url(#filter0_b_40_1381)">
      <rect
        width="191"
        height="46"
        rx="20"
        fill="url(#paint0_linear_40_1381)"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_40_1381"
        x="-50"
        y="-50"
        width="291"
        height="146"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="25" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_40_1381"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_40_1381"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_40_1381"
        x1="95.5"
        y1="-0.287498"
        x2="115.062"
        y2="60.8635"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#060B26" stop-opacity="0.74" />
        <stop offset="1" stop-color="#1A1F37" stop-opacity="0.5" />
      </linearGradient>
    </defs>
  </svg>
)

const EllipseSvg = () => (
  <svg
    width="350"
    height="351"
    viewBox="0 0 396 395"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="animate-pulse2"
  >
    <path
      d="M193.377 19.06C193.09 8.01807 183.88 -0.804812 172.924 0.593793C128.792 6.22701 87.6227 26.604 56.2823 58.7246C20.2644 95.6391 0.0717046 145.151 0.000190346 196.725C-0.0713239 248.3 19.984 297.868 55.8993 334.882C91.8147 371.896 140.755 393.436 192.309 394.918C243.862 396.401 293.96 377.709 331.943 342.82C369.926 307.93 392.796 259.597 395.688 208.104C398.581 156.61 381.266 106.02 347.429 67.0967C317.986 33.2282 278.056 10.5191 234.321 2.35931C223.463 0.3334 213.761 8.61247 212.84 19.6197L208.846 67.3604C207.925 78.3676 216.19 87.8597 226.849 90.7542C247.756 96.4312 266.679 108.198 281.086 124.771C299.9 146.413 309.527 174.542 307.919 203.174C306.311 231.806 293.595 258.68 272.475 278.079C251.356 297.478 223.501 307.871 194.836 307.047C166.171 306.223 138.959 294.246 118.989 273.665C99.019 253.085 87.8678 225.524 87.9076 196.847C87.9473 168.171 99.1749 140.641 119.202 120.116C134.537 104.398 154.105 93.7383 175.303 89.272C186.112 86.9948 194.908 77.9933 194.621 66.9514L193.377 19.06Z"
      fill="url(#paint0_linear_40_1371)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_40_1371"
        x1="101.5"
        y1="16"
        x2="344"
        y2="303"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A979EC" />
        <stop offset="1" stop-color="#604486" stop-opacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
)

const LineSvg = ({ width = 164, height = 10 }) => {
  const strokeWidth = height

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      className="animate-pulse"
    >
      <path
        opacity="0.6"
        d={`M${strokeWidth / 2} ${height / 2}H${width - strokeWidth / 2}`}
        stroke="url(#paint0_linear_40_1625)"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_40_1625"
          x1={-19.5}
          y1={height / 2}
          x2={width + 19.5}
          y2={height / 2}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A0AEC0" />
          <stop offset="1" stopColor="#96A4B7" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

const LongLineSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="244"
    height="10"
    viewBox="0 0 244 10"
    fill="none"
    className="animate-pulse"
  >
    <path
      opacity="0.6"
      d="M5 5H239"
      stroke="url(#paint0_linear_40_1606)"
      stroke-width="10"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_40_1606"
        x1="-29.9573"
        y1="5"
        x2="263"
        y2="5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A0AEC0" />
        <stop offset="1" stop-color="#96A4B7" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

const Line627 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="10"
    viewBox="0 0 100% 10"
    fill="none"
    className="animate-pulse"
  >
    <path
      opacity="0.6"
      d="M5 5H632"
      stroke="url(#paint0_linear_40_1621)"
      stroke-width="10"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_40_1621"
        x1="-88.6677"
        y1="5"
        x2="721.845"
        y2="5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A0AEC0" />
        <stop offset="1" stop-color="#96A4B7" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

const Line338 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="348"
    height="10"
    viewBox="0 0 348 10"
    fill="none"
    className="animate-pulse3"
  >
    <path
      opacity="0.6"
      d="M5 5H343"
      stroke="url(#paint0_linear_40_1615)"
      stroke-width="10"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_40_1615"
        x1="-45.4939"
        y1="5"
        x2="391.433"
        y2="5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A0AEC0" />
        <stop offset="1" stop-color="#96A4B7" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
)
